export default function SpaRegister() {
  return (
    <div className="min-h-screen bg-off-white flex items-center justify-center px-4 pt-20">
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-2xl bg-soft-gold-50 flex items-center justify-center mx-auto mb-6">
          <i className="ri-store-2-line text-soft-gold-600 text-2xl" />
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-deep-navy-500 mb-3">
          Spa İşletmesi Başvuru Formu
        </h1>
        <p className="text-sm text-gray-500 leading-relaxed mb-6">
          Spa işletmesi başvuru formu yakında aktif edilecektir. Şu anlık ön kayıt süreci devam etmektedir.
        </p>
        <p className="text-xs text-gray-400">
          İlk aşamada Kayseri, Antalya ve İstanbul şehirlerinde hizmet verilecektir.
        </p>
      </div>
    </div>
  );
}